export enum DrawerMode {
  Create = 'create',
  Edit = 'edit',
}
